import { render, staticRenderFns } from "./artList.vue?vue&type=template&id=028809c4&"
import script from "./artList.vue?vue&type=script&lang=js&"
export * from "./artList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports